import React from 'react';

const Services = () => {
  const services = [
    {
      icon: '💼',
      title: 'Finance Consultancy',
      description: 'Expert financial technology solutions, regulatory compliance, and digital transformation for banking and fintech companies.',
      features: ['Risk Management Systems', 'Trading Platforms', 'Regulatory Compliance', 'Digital Banking Solutions']
    },
    {
      icon: '🏥',
      title: 'Medical Consultancy',
      description: 'Healthcare IT solutions that meet strict industry standards and improve patient outcomes through innovative technology.',
      features: ['HIPAA Compliant Systems', 'Electronic Health Records', 'Medical Device Integration', 'Telemedicine Platforms']
    },
    {
      icon: '☁️',
      title: 'Azure Cloud Solutions',
      description: 'Comprehensive cloud transformation services leveraging Microsoft Azure for scalability, security, and performance.',
      features: ['Cloud Migration', 'DevOps Implementation', 'Infrastructure as Code', 'Kubernetes Orchestration']
    },
    {
      icon: '⚙️',
      title: 'Custom Applications',
      description: 'Bespoke software development tailored to your unique business requirements and industry standards.',
      features: ['Enterprise Applications', 'API Development', 'Database Design', 'System Integration']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Our Expertise</h2>
          <p className="section-subtitle">
            Comprehensive consultancy services designed to accelerate your business growth
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;